/**
 * R100 · TimezoneSelect
 * ---------------------------------------------------------------
 * Datalist-backed searchable timezone picker. Uses
 * `Intl.supportedValuesOf('timeZone')` when available (modern browsers)
 * and falls back to a curated short list.
 *
 * Value is a raw IANA name (e.g. "Asia/Kolkata"). Empty string clears
 * (parent stores `null`).
 */
import { useMemo } from "react";

const FALLBACK_TZS = [
  "Asia/Kolkata", "Asia/Dubai", "Asia/Singapore", "Asia/Tokyo", "Asia/Shanghai",
  "Europe/London", "Europe/Paris", "Europe/Berlin", "Europe/Amsterdam",
  "America/New_York", "America/Chicago", "America/Los_Angeles", "America/Denver",
  "America/Sao_Paulo", "America/Toronto",
  "Australia/Sydney", "Australia/Melbourne", "Pacific/Auckland",
  "Africa/Johannesburg", "UTC",
];

export default function TimezoneSelect({ value, onChange, testid = "tz-select", disabled = false }) {
  const zones = useMemo(() => {
    try {
      // eslint-disable-next-line no-undef
      if (typeof Intl.supportedValuesOf === "function") {
        return Intl.supportedValuesOf("timeZone");
      }
    } catch { /* ignore */ }
    return FALLBACK_TZS;
  }, []);
  const listId = `${testid}-list`;
  return (
    <>
      <input
        type="text"
        value={value || ""}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.value.trim())}
        placeholder="e.g. Asia/Kolkata"
        list={listId}
        className="h-9 w-full border border-border rounded-none px-2 text-xs bg-background"
        data-testid={testid}
        autoComplete="off"
      />
      <datalist id={listId}>
        {zones.map((z) => <option key={z} value={z} />)}
      </datalist>
    </>
  );
}
